module.exports = __webpack_public_path__ + "static/media/fla.79527788.svg";